import { render, staticRenderFns } from "./additional_addresses.vue?vue&type=template&id=66ce5312&scoped=true&"
import script from "./additional_addresses.vue?vue&type=script&lang=js&"
export * from "./additional_addresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ce5312",
  null
  
)

export default component.exports